module.exports = __webpack_public_path__ + "images/navigation/starter-kit-7034d78c.jpg";